import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledIcon = styled.div<{ $icon: string; $color?: string }>`
	width: 20px;
	height: 20px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${(props) => props.$icon});
	mask-size: 20px 20px;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${(props) => props.$icon});
	-webkit-mask-size: 20px 20px;
	background-color: ${(props) => props.$color || '#FFFFFF'};
	opacity: ${(props) => (props.$color ? 1 : 0.5)};
	transition:
		opacity 0.3s ease,
		background-color 0.3s ease;
`;

const StyledTab = styled.div<{ $selected?: boolean; $color?: string }>`
	position: relative;
	display: flex;
	align-items: center;
	gap: 20px;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		text-transform: uppercase;
		color: ${(props) => props.$color || '#FFFFFF'};
		opacity: ${(props) => (props.$color ? 1 : 0.25)};
		transition:
			opacity 0.3s ease,
			color 0.3s ease;
	}

	${(props) =>
		props.$selected &&
		css`
			${Text} {
				opacity: 1;
			}

			${StyledIcon} {
				opacity: 1;
			}
		`}
`;

const StyledCount = styled.div`
	width: 16px;
	height: 16px;
	background-color: #ff3d3d;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;

	${Text} {
		font-style: italic;
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
		opacity: 1;
	}
`;

const StyledTabContainer = styled.div<{ $color?: string }>`
	position: relative;
	display: flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;

	&:hover {
		${(props) =>
			!props.$color
				? css`
						${Text} {
							opacity: 1;
						}

						${StyledIcon} {
							opacity: 1;
						}
				  `
				: css`
						${Text} {
							color: #ffffff;
						}

						${StyledIcon} {
							background-color: #ffffff;
						}
				  `}
	}
`;

export { StyledCount, StyledIcon, StyledTab, StyledTabContainer };
